import Vue from "vue";
import reactiveCache from "./reactive-cache";
import { Item } from "./item";

const hintsShown = new Vue({
  data: {},
  computed: {
    doneVsSelect: addHintInfo("doneVsSelect"),
    taskVsNote: addHintInfo("taskVsNote"),
    usingWeeks: addHintInfo("usingWeeks"),
    howToInsert: addHintInfo("howToInsert"),
  },
  methods: {},
});

export default hintsShown;

function addHintInfo(key) {
  return {
    get() {
      const doc = reactiveCache.get(".hints/" + key);
      return doc?.value ?? false;
    },
    set(value) {
      let doc = reactiveCache.get(".hints/" + key);
      if (!doc) {
        doc = new Item({ _id: ".hints/" + key }, reactiveCache, reactiveCache.defaultDB);
      }
      return doc.clone({ value }).save();
    },
  };
}
